import i18n from '@/lib/i18n';
import { createPostalCodeRefinement } from '@/services/api/mainstream';

const { refinement, params } = createPostalCodeRefinement<{ countryOfResidency?: string; postCode?: string }>({
  getParts: (data) => ({ country: data?.countryOfResidency, postCode: data?.postCode }),
  message: i18n.t('personalInformation.errors.postCode'),
  path: ['postCode'],
});

export const postalCodeRefinement = refinement;

export const postalCodeRefinementParams = params;
